<template>
    <div id="workflow-settings">
        <SupsisButton @click="createWorkflow"> Create </SupsisButton>
        <div class="supsis-table">
            <a-table :columns="columns" :data-source="workflows" :pagination="false" :customRow="customRow">
                <div slot="id" slot-scope="record" style="margin: 0">{{ record.slice(0, 9) }}</div>
                <div slot="name" slot-scope="record" style="margin: 0">{{ record }}</div>
                <div slot="default" slot-scope="record, data" style="margin: 0">
                    <a-checkbox
                        class="supsis-checkbox"
                        v-model="data.default"
                        @change="changeDefaultWorkflow(record, data)"
                    />
                </div>
                <!-- <div slot="delete" slot-scope="record, data" style="margin: 0">
                    <div class="material-icons">delete</div>
                </div> -->
            </a-table>
        </div>
        <div class="total-workflow-container">Total: {{ workflows.length }}</div>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import SupsisButton from "../../common/SupsisButton.vue";

export default {
    name: "WorkflowSettings",
    components: {
        SupsisButton,
    },
    data: () => ({
        columns: [
            { title: "ID", dataIndex: "_id", key: "id", scopedSlots: { customRender: "id" } },
            { title: "Name", dataIndex: "title", key: "name", scopedSlots: { customRender: "name" } },
            { title: "Default", dataIndex: "default", key: "default", scopedSlots: { customRender: "default" } },
            // { title: "Default", dataIndex: "delete", key: "delete", scopedSlots: { customRender: "delete" } },
        ],
        form: {
            title: null,
            description: null,
            pipelines: [],
        },
    }),
    computed: {
        ...mapState({
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc.push({
                        value: user._id,
                        label: user.name,
                    });
                    return acc;
                }, []),
            workflows: (state) => state.tasks.workflows,
        }),
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
            setWorkflows: "tasks/setWorkflows",
            updateWorkflow: "tasks/updateWorkflow",
        }),
        customRow(record) {
            return {
                on: {
                    dblclick: (e) => {
                        this.addNewWindow({
                            type: "edit-workflow",
                            title: "Edit Workflow",
                            details: {
                                workflowId: record._id,
                            },
                        });
                    },
                },
            };
        },
        createWorkflow() {
            this.addNewWindow({
                type: "create-workflow",
                title: "Create Workflow",
            });
        },
        changeDefaultWorkflow(record, data) {
            const workflows = this.workflows.map((workflow) => {
                workflow.default = false;
                if (workflow.id === data.id) {
                    workflow.default = true;
                }
                return workflow;
            });
            this.setWorkflows(workflows);
            this.updateWorkflow({
                workflowId: data._id,
                params: {
                    default: true,
                },
            });
        },
    },
    mounted() {},
    watch: {
        form: {
            deep: true,
            handler() {
                this.$emit("update-form", this.form);
            },
        },
    },
};
</script>
<style lang="scss">
#workflow-settings {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    .supsis-table {
        .ant-table-body {
            border: 1px solid #e8e8e8;
        }
        .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
            background-color: #fff4de !important;
        }
        .ant-table-thead > tr > th {
            background-color: transparent !important;
        }
        tr.ant-table-expanded-row {
            background-color: transparent !important;
        }
        .ant-table-row-expand-icon  {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .ant-table-row-expand-icon:focus,
        .ant-table-row-expand-icon:hover {
            color: #ffa800 !important;
            background-color: #fff4de !important;
        }
        .ant-btn:hover,
        .ant-btn:focus {
            color: #ffa800 !important;
            border-color: #ffa800;
        }
    }
    .total-workflow-container {
        padding: 10px;
        border: 1px solid #e6e9f2;
        border-radius: 4px;
    }
    .supsis-checkbox {
        .ant-checkbox-inner {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            &::after {
                border: 2px solid #fff;
                left: 20%;
                width: 7px;
                height: 11px;
                border-top: 0;
                border-left: 0;
            }
        }
        .ant-checkbox.ant-checkbox-checked {
            .ant-checkbox-inner {
                border: 3px solid #ec4b1d !important;
                background-color: #ec4b1d !important;
            }
        }
        .ant-checkbox-checked::after {
            border: 1px solid #ec4b1d !important;
        }
        .ant-checkbox-wrapper:hover .ant-checkbox-inner,
        .ant-checkbox:hover .ant-checkbox-inner,
        .ant-checkbox-input:focus + .ant-checkbox-inner {
            border: 1px solid #ec4b1d !important;
        }
    }
}
</style>
